import { GridCellProps } from '@progress/kendo-react-grid';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { convertToDate } from 'src/utils/formatTime';

const ShoppingCartLastPurchaseDateCell = (props: GridCellProps) => {
  const rawValue = props.dataItem?.lastPurchaseDateRaw as string | null | undefined;

  const displayValue = useMemo(() => {
    try {
      if (isEmpty(rawValue)) return '';
      return convertToDate(rawValue as string);
    } catch (error) {
      return '';
    }
  }, [rawValue]);

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={displayValue}>
      <span>{displayValue}</span>
    </GridCellBase>
  );
};

export default ShoppingCartLastPurchaseDateCell;
